import { FunctionalComponent, h, ComponentChildren } from "preact";
import { useEffect, useState, useRef } from "preact/hooks";
import { useAppDispatch, useAppSelector } from "../../redux/hooks";
import { isMobileOnly as isMobileOnlyReact } from "react-device-detect";
import {
  getIsEdge,
  get_AI_URI_BASE,
  get_CDN_BASE_URL,
  get_IS_CDN77,
  get_WorkSpaces_ROW_ID,
} from "../../configs/env";
import axios from "axios";
import desktop from "./desktop.css";
import { getEdgeSassToken, getEdgeUserLoginSession, getPortal, getSassToken, removeMultipleSlashes } from "../../utils";
import { get_APP_URI_BASE } from "../../configs/env";
import loader from "./loader.css";
import DataRowDisplay from "./RowDisplay";
import { setChatThemeSetting } from "../../redux/slices/chatbotSlice";
import styles from "./mobile.css";
import WatermarkOverlay from "../../components/DocumentWaterMark";
import logger from "../../logger";
interface Props {
  workspaceId: string;
  kappId: string;
  portalId?: string;
  docId: string;
  guid: string;
  chatbotFlag?: string;
  isDrawerOpen?: boolean;
  srcUrl: string;
  setSrcUrl: (value: string) => void;
  isMobileExpand?: boolean;
  isWatermarkEnabled?: boolean;
}

type TabProps = {
  isActive: boolean;
  onClick: () => void;
  children: ComponentChildren;
};

const ChatbotSheet: FunctionalComponent<Props> = (props: Props) => {
  const {
    workspaceId,
    kappId,
    portalId,
    isWatermarkEnabled,
    docId,
    guid,
    chatbotFlag,
    isDrawerOpen,
    srcUrl,
    setSrcUrl,
    isMobileExpand,
  } = props;
  const alias = useAppSelector((state) => state.alias);
  const globals = useAppSelector((state) => state.globals);
  const auth = useAppSelector((state) => state.auth);
  const appearance = useAppSelector((state) => state.appearance);

  const dispatch = useAppDispatch();
  const [html, setHtml] = useState("");
  const [sheetName, setSheetName] = useState("");
  const [start_Cell, setStartCell] = useState("");
  const [isLoaded, setIsLoaded] = useState(false);
  const [error, setError] = useState("");
  const [rowNum, setrowNum] = useState("");
  const [activeTab, setActiveTab] = useState<string>("tab1");
  const iframeRef = useRef(null);
  const [enableDisplayRow, setenableDisplayRow] = useState(false);
  const [percentage, setPercentage] = useState(0);

  // Watermark data preparation
  const date = new Date();
  let edgeUser: { user?: { name: string; email: string } } = {};
  const data = localStorage.getItem("Web-app-edgeUser");

  try {
    if (data) {
      edgeUser = JSON.parse(data) as typeof edgeUser;
    }
  } catch { }

  const email =
    auth.auth0User?.email ?? auth.korraUser?.email ?? edgeUser?.user?.email;
  const name = auth.auth0User?.name ?? edgeUser?.user?.name ?? "Unknown User";

  const formattedDateTime = `${date.toLocaleDateString()} ${date.toLocaleTimeString(
    [],
    { hour: "2-digit", minute: "2-digit" }
  )}`;

  const line1 = "Applied Material Confidential Use Only";
  const line2 = formattedDateTime;
  const line3 = name + " " + email;

  const applied = [
    "67b9703f2ea7728ebfb05d67",
    "671505dfbc426e5ac9125493",
    "67b9703f2ea7728ebfb05d68",
    "67b9703f2ea7728ebfb05d69",
  ];

  const finalLine1 = applied.includes(alias.workspaceId) ? line1 : null;

  useEffect(() => {
    const handleGetSettings = async () => {
      let portal = await getPortal(
        alias.workspaceId,
        alias.portalId,
        globals.userId,
        globals.jwtUserIdToken,
        dispatch
      );

      let publishTheme = portal?.chatThemes?.find(
        (item: any) => item.name === "preview"
      );
      if (publishTheme) dispatch(setChatThemeSetting(publishTheme));
    };
    if (alias.workspaceId && alias.portalId && globals.userId && chatbotFlag) {
      handleGetSettings();
    }
  }, [
    alias.workspaceId,
    alias.portalId,
    globals.userId,
    globals.jwtUserIdToken,
  ]);
  useEffect(() => {
    if (isDrawerOpen) document.title = "Korra Sheet Viewer";
  }, [isDrawerOpen]);
  useEffect(() => {
    let workspaces = get_WorkSpaces_ROW_ID();
    if (workspaces) {
      let workSpacesArray = (workspaces as string).split(",");
      if (workSpacesArray.includes(portalId || alias.portalId)) {
        setenableDisplayRow(true);
      }
    }
  }, [alias.workspaceId, workspaceId]);
  useEffect(() => {
    if (
      (workspaceId || alias.workspaceId) &&
      (portalId || alias.portalId || kappId) &&
      kappId &&
      guid &&
      docId &&
      isDrawerOpen
    ) {
      (async () => {
        try {
          const sectionDetailsUri =
            get_AI_URI_BASE() +
            `/api/getSectionDetails/company/${workspaceId || alias.workspaceId
            }/kapp/${kappId}/doc/${docId}/section/${guid}`;

          const sectionDetails = await axios(sectionDetailsUri, {
            headers: {
              Authorization: `Bearer ${globals.jwtUserIdToken}`,
              "User-Id": globals.userId,
              "Portal-Id": portalId || alias.portalId,
            },
          });
          document.title = sectionDetails.data[0]._source.srcUrl
            .split(/(\\|\/)/g)
            .pop();

          let srcUrl = sectionDetails.data[0]._source.srcUrl;
          
          // Handle Azure blob storage URLs
          if (srcUrl.includes("korrastorage.blob.core.windows.net")) {
            srcUrl = srcUrl.replace(
              "https://korrastorage.blob.core.windows.net/",
              get_CDN_BASE_URL() + "/"
            );
          } else if (srcUrl.includes("/storage")) {
            srcUrl = srcUrl.replace(
              "/storage",
              get_IS_CDN77()
                ? "https://1425625160.rsc.cdn77.org/assistants//"
                : get_CDN_BASE_URL()
            );
          } else if (!srcUrl.startsWith("https://")) {
            // Only prepend CDN base if not already an absolute URL
            srcUrl = get_CDN_BASE_URL() + "/" + srcUrl;
          }
          
          // remove duplicate production segments (with or without slash between)
          srcUrl = srcUrl.replace(/\/production\/?production\//g, '/production/');
          // remove any double slashes in the URL path
          srcUrl = removeMultipleSlashes(srcUrl);

          // console.log(srcUrl);

          if (!get_IS_CDN77()) {
            if (getIsEdge()) {
              try {
                const edgeUser = await getEdgeUserLoginSession();
                const edgeSas = await getEdgeSassToken(
                  edgeUser?.user.email
                );
                srcUrl += "?sasToken=" + edgeSas;

              } catch (error: any) {
                /** Error type */
                // general error
                console.error(error);
              }
            }
            else if (auth.azureSasToken) {
              srcUrl += "?" + auth.azureSasToken;
            } else {
              // get sas token then attach
              const st = await getSassToken(
                workspaceId || alias.workspaceId,
                portalId || alias.portalId || "",
                globals.userId,
                globals.jwtUserIdToken,
                getIsEdge() === true ? true : false
              );
              srcUrl += "?" + st;
            }
          }
          const Sheet_Name =
            sectionDetails.data[0]._source.action.xlsParams.SheetName;
          const StartCell =
            sectionDetails.data[0]._source.action.xlsParams.StartCell;
          if (getIsEdge()) {
            srcUrl = srcUrl.replace("/datadrive/localCDN", "")
          }
          setSrcUrl(srcUrl);
          setSheetName(Sheet_Name);
          setStartCell(StartCell);
          // console.log(start_Cell);
          const uri = get_APP_URI_BASE();

          fetch(uri + "/assets/sheetjs/XlsxViewer.html")
            .then((response) => {
              // Check if the request was successful
              if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
              }
              return response.text();
            })
            .then((html) => {
              setIsLoaded(false);
              setHtml(html);

              const iframe: any = iframeRef.current;

              if (iframe) {
                // Get the document object of the iframe
                const iframeDocument: Document = iframe.contentDocument;

                // Write the HTML data into the iframe's document

                iframeDocument.write(html);
                if (uri) {
                  const headElement = iframeDocument.head;
                  const bodyElement = iframeDocument.body;

                  const xspreadStylesheet =
                    iframeDocument.createElement("link");
                  xspreadStylesheet.rel = "stylesheet";
                  xspreadStylesheet.href =
                    uri + "/assets/sheetjs/xspreadsheet.css";
                  headElement.appendChild(xspreadStylesheet);

                  function loadScript(src: any) {
                    return new Promise((resolve, reject) => {
                      const script = iframeDocument.createElement("script");
                      script.src = src;
                      script.onload = resolve;
                      script.onerror = () =>
                        reject(new Error(`Failed to load ${src}`));
                      bodyElement.appendChild(script);
                      setPercentage((percentage) => percentage + 20);
                    });
                  }

                  async function loadScriptsInOrder() {
                    try {
                      await loadScript(uri + "/assets/sheetjs/xspreadsheet.js");
                      await loadScript(uri + "/assets/sheetjs/shim.js");
                      await loadScript(uri + "/assets/sheetjs/full.js");
                      await loadScript(uri + "/assets/sheetjs/xlsxspread.js");
                      await loadScript(uri + "/assets/sheetjs/main.js");
                      logger.log({
                        message: "All SheetJS scripts loaded successfully",
                        portal_alias: portalId || alias.portalId,
                        document_name: document.title
                      });
                      setTimeout(() => setIsLoaded(true), 1000);
                    } catch (error) {
                      logger.error({
                        message: "Failed to load SheetJS scripts",
                        portal_alias: portalId || alias.portalId,
                        document_name: document.title,
                        error: error,
                        stacktrace: (error as any)?.stack
                      });
                    }
                  }

                  loadScriptsInOrder();
                }

                const inputElement: HTMLInputElement | null =
                  iframeDocument.getElementById("xlf") as HTMLInputElement;
                const SheetName: HTMLInputElement | null =
                  iframeDocument.getElementById("Fsheet") as HTMLInputElement;
                const RowNum: HTMLInputElement | null =
                  iframeDocument.getElementById("RowNum") as HTMLInputElement;

                // Set the value property of the input,sheetname and row number elements
                if (inputElement) {
                  inputElement.value = srcUrl;
                }
                if (SheetName) {
                  // console.log(Sheet_Name);
                  SheetName.value = Sheet_Name;
                }

                if (RowNum) {
                  const numbers: string[] | null =
                    StartCell.match(/\d+(\.\d+)?/g);
                  // numbers will contain an array of matched numbers
                  // console.log(numbers);
                  if (numbers) {
                    setrowNum(numbers[0]);
                    RowNum.value = numbers[0];
                  }
                }

                iframeDocument.close();
              }
            });
        } catch (err: any) {
          setError("Network error");
        }
      })();
    }
  }, [
    alias.workspaceId,
    workspaceId,
    alias.portalId,
    portalId,
    kappId,
    docId,
    guid,
    isDrawerOpen,
  ]);
  const Tab: FunctionalComponent<TabProps> = ({
    isActive,
    onClick,
    children,
  }) => {
    const tabStyle = {
      padding: "10px 15px",
      cursor: "pointer",
      backgroundColor: isActive ? "#0093ff" : "#E8E8E8",
      color: isActive ? "white" : "black",
      fontWeight: isActive ? "bold" : "normal",
      borderRight: "2px solid #ccc",
    };

    return (
      <div style={tabStyle} onClick={onClick}>
        {children}
      </div>
    );
  };
  const WithRowDisplay = (
    <div>
      {!getIsEdge() && <a
        href={srcUrl}
        download
        // className={loader.downloadButton}
        style={{
          // marginTop: "90px",
          position: "absolute",
          width: "150px",
          left: "40%",
          top: "1%",
          fontSize: "13px",
          zIndex: 10,
          color: "#0093ff",
          textDecoration: "none",
          //   display: enableFileRepositoryDestinationLink ? "none" : "flex",
        }}
      >
        Download Table 🠟
      </a>}
      <div
        className={loader.loaderChatbotContainer}
        style={{
          marginTop: "90px",
          display: isLoaded ? "none" : "block",
        }}
      >
        <div
          className={loader.loaderLine}
          style={{ width: percentage + "%" }}
        ></div>
      </div>
      <div
        style={{
          display: "flex",
          marginTop: isLoaded ? "90px" : "1px",
          borderBottom: "2px solid ",
        }}
      >
        <Tab
          isActive={activeTab === "tab1"}
          onClick={() => setActiveTab("tab1")}
        >
          {sheetName + ", " + start_Cell}
        </Tab>
        <Tab
          isActive={activeTab === "tab2"}
          onClick={() => setActiveTab("tab2")}
        >
          Table
        </Tab>
      </div>
      <div style={{ display: activeTab === "tab1" ? "block" : "none" }}>
        <div>
          <DataRowDisplay
            url={srcUrl}
            rowNumber={rowNum}
            sheet={sheetName}
          ></DataRowDisplay>
        </div>
      </div>
      <div style={{ display: activeTab === "tab2" ? "block" : "none" }}>
        <div style={{ backgroundColor: "green" }}>
          <iframe
            ref={iframeRef}
            width="100%"
            height={window.innerHeight - 90}
            style={{ marginTop: "2px" }}
            frameBorder="0"
            scrolling="no"
            title="HTML Content"
          />
        </div>
      </div>
    </div>
  );

  const WithOutRowDisplay = (
    <div className={isMobileExpand ? styles.Mcontainer : ""}>
      {appearance.documentWatermark && (
        <WatermarkOverlay />
      )}
      <div
        style={{
          color: "black",
          textAlign: "center",
          position: "relative",
          top: "22px",
        }}
      >
        {sheetName}
      </div>
      <div
        className={loader.loaderChatbotContainer}
        style={{
          top: "48px",
          display: isLoaded ? "none" : "block",
        }}
      >
        <div
          className={loader.loaderLine}
          style={{ width: percentage + "%" }}
        ></div>
      </div>
      <div key={guid}>
        <iframe
          ref={iframeRef}
          className={
            isMobileOnlyReact && isMobileExpand
              ? desktop.Mobile_frame_Two
              : isMobileOnlyReact && !isMobileExpand
                ? desktop.Mobile_frame
                : desktop.desktop_frame
          }
          style={{ top: "28px" }}
          id={isMobileOnlyReact ? "Mobile_frame" : "desktop_frame"}
          width="100%"
          height={window.innerHeight - 90}
          frameBorder="0"
          scrolling="no"
          title="HTML Content"
        />

      </div>
    </div>
  );

  return isDrawerOpen ? WithOutRowDisplay : null;
};

export default ChatbotSheet;
